// AVISO: texto gerado como rascunho inicial para dar um ponto de partida.
// Precisa ser revisado por um advogado antes de valer como documento legal
// oficial da empresa. Razão Social e CNPJ vêm de /admin/configuracoes —
// preencher por lá.
import { createFileRoute } from "@tanstack/react-router";
import { instagramHandle, useStoreSettings } from "@/lib/settings.functions";
import { formatPhone } from "@/lib/format";
import { requestOriginQuery } from "@/lib/seo.functions";

export const Route = createFileRoute("/termos")({
  loader: async ({ context }) => ({
    origin: await context.queryClient.ensureQueryData(requestOriginQuery()),
  }),
  head: ({ loaderData }) => {
    const canonicalUrl = loaderData?.origin ? `${loaderData.origin}/termos` : undefined;
    return {
      meta: [
        { title: "Termos de Uso — Loja EG Elétrica" },
        { name: "description", content: "Termos de uso da loja online EG Elétrica." },
        ...(canonicalUrl ? [{ property: "og:url", content: canonicalUrl }] : []),
      ],
      links: canonicalUrl ? [{ rel: "canonical", href: canonicalUrl }] : [],
    };
  },
  component: TermosPage,
});

function TermosPage() {
  const settings = useStoreSettings();

  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <h1 className="font-display text-2xl font-bold text-eg-dark mb-2">Termos de Uso</h1>
      <p className="mb-8 text-sm text-muted-foreground">Última atualização: 31 de julho de 2026.</p>

      <div className="space-y-6 text-sm leading-relaxed text-eg-dark">
        <section>
          <h2 className="mb-2 font-display font-bold">1. Aceitação dos termos</h2>
          <p>
            Ao acessar e utilizar esta loja online, você concorda com estes Termos de Uso. Se não
            concordar com alguma condição, pedimos que não utilize o site.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">2. Identificação</h2>
          <p>
            Esta loja é operada por{" "}
            <strong>
              {settings.razao_social ?? settings.nome_fantasia}
              {settings.razao_social ? ` — ${settings.nome_fantasia}` : ""}
            </strong>
            {settings.cnpj && (
              <>
                , inscrita no CNPJ <strong>{settings.cnpj}</strong>
              </>
            )}
            , com sede em {settings.cidade}/{settings.uf}.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">3. Cadastro e conta</h2>
          <p>
            Você pode comprar sem se cadastrar (checkout como convidado) ou criar uma conta para
            acompanhar seus pedidos. É sua responsabilidade manter a confidencialidade da senha e
            informar dados verdadeiros, completos e atualizados.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">4. Produtos, preços e disponibilidade</h2>
          <p>
            Fazemos o possível para manter descrições, imagens e preços precisos. Preços podem ser
            alterados sem aviso prévio, e a disponibilidade de estoque é confirmada apenas no
            momento da finalização do pedido. Em caso de erro evidente de preço ou descrição,
            reservamo-nos o direito de cancelar o pedido, com reembolso integral.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">5. Pedidos e pagamento</h2>
          <p>
            Os pagamentos são processados pelo Mercado Pago (Pix e cartão de crédito). O pedido é
            confirmado somente após a aprovação do pagamento. Guardamos os dados do pedido
            (produtos, valores, endereço) para processar a compra e cumprir obrigações legais.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">6. Entrega</h2>
          <p>
            O valor e prazo de frete são combinados diretamente com você após a finalização do
            pedido. Produtos sob orçamento (linha personalizada) têm prazo de produção informado
            individualmente.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">7. Propriedade intelectual</h2>
          <p>
            Marca, logotipo, textos, imagens e demais conteúdos deste site pertencem à{" "}
            {settings.nome_fantasia} ou a seus licenciadores, sendo proibida a reprodução sem
            autorização.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">8. Limitação de responsabilidade</h2>
          <p>
            Não nos responsabilizamos por indisponibilidades temporárias do site decorrentes de
            manutenção ou fatores fora do nosso controle. Nada nestes Termos exclui direitos que não
            possam ser legalmente limitados, especialmente os previstos no Código de Defesa do
            Consumidor.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">9. Alterações destes termos</h2>
          <p>
            Podemos atualizar estes Termos periodicamente. A versão vigente é sempre a publicada
            nesta página, com a data de atualização indicada no topo.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">10. Lei aplicável e foro</h2>
          <p>
            Estes Termos são regidos pelas leis brasileiras. Fica eleito o foro da comarca do
            domicílio do consumidor para dirimir eventuais controvérsias, conforme o Código de
            Defesa do Consumidor.
          </p>
        </section>

        <section>
          <h2 className="mb-2 font-display font-bold">11. Contato</h2>
          <p>
            Dúvidas sobre estes Termos podem ser enviadas pelo WhatsApp{" "}
            {formatPhone(settings.whatsapp_number.slice(-11))} ou pelo Instagram{" "}
            {instagramHandle(settings.instagram_url)}.
          </p>
        </section>
      </div>
    </div>
  );
}
